import { makeStyles } from "@material-ui/core/styles";
import { calculateFontSize } from "../../CustomHooks/useThemeHook";

const useStyles = makeStyles((theme) => ({
  roottt: {
    paddingBottom: theme.spacing(1),
    // overflowX: "auto",
    // overflowY: "auto",
    // height: "100vh",
    // width: "100%",
    // overflow: "scroll",
    // scrollbarWidth: "none" /* For Firefox */,
    // "-ms-overflow-style": "none" /* For Internet Explorer and Edge */,
    // "&::-webkit-scrollbar": {
    //   display: "none" /* For Chrome, Safari, and Opera */,
    // },
  },
  title: {
    ...theme.typography.poppins,
    // fontSize: theme.typography.pxToRem(24),
    fontSize: calculateFontSize(24, theme.palette.common.fontVariation),
    fontWeight: 700,
    // color: theme.palette.common.normalTitle,
    color: theme?.palette?.common?.themeFontColor,
  },

  categoryName: {
    padding: theme.spacing(1.3),
    background: "#ffffff",
    // background: '#cdb4db',
    textAlign: "center",
    color: "#000000",
    borderRadius: "0 0 30px 30px",
    boxShadow: "0px 4px 8px rgb(0 0 0 / 8%)",
    [theme.breakpoints.down("xs")]: {
      padding: "10px",
    },
  },
  label: {
    ...theme.typography.poppins,
    fontSize: calculateFontSize(12, theme.palette.common.fontVariation),
    fontWeight: 700,
    color: "#000",
  },
  img: {
    borderRadius: "30px 30px 0 0",
    boxShadow: "0px 4px 8px rgb(0 0 0 / 8%)",
    [theme.breakpoints.down("xs")]: {
      height: "100px",
    },
  },
  catCont: {
    "&:hover": {
      opacity: "0.8",
      transform: "scale(1.01)",
    },
  },
}));

export default useStyles;
